import { Heading, Stepper } from "@/components";
import useAddEditUser from "./useAddEditUser";
import { steps } from "./consts";
import { Step2, Step3, Step4 } from "./components";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

const AddEditUser = () => {
  const {
    currentStep,
    onNextStepClick,
    onBackClick,
    isView,
    onStepperClick,
    onPreviousStepClick,
  } = useAddEditUser();
  const isMobile = useIsMobile();

  return (
    <div className="p-4 md:p-6 !pt-0">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <Heading title={"View User"} />
        <div className={cn(isMobile ? "pt-4" : "pt-6 px-6")}>
          <Stepper
            steps={steps?.map((step) => ({
              ...step,
              ...(step.id == 1
                ? {
                    hide: true,
                  }
                : {}),
              displayId: (step.id - 1).toString(),
            }))}
            currentStep={currentStep}
            onStepperClick={onStepperClick}
          />
        </div>
      </div>

      {currentStep == 1 ? (
        <Step2
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : currentStep == 2 ? (
        <Step3
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : currentStep == 3 ? (
        <Step4
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default AddEditUser;
